import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[prcinsOnlyNumber]'
})
export class OnlyNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    // Only handle paste event if element has prcinsAllowPaste directive
    if (this.el.nativeElement.hasAttribute('prcinsAllowPaste')) {
      const clipboardData = event.clipboardData || window['clipboardData'];
      const pastedText = clipboardData.getData('text');
      
      // If pasted content is not a number, prevent the default action
      if (!/^\d+$/.test(pastedText)) {
        event.preventDefault();
      }
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent>event;
    
    // Check if element has prcinsAllowPaste directive
    const hasAllowPasteDirective = this.el.nativeElement.hasAttribute('prcinsAllowPaste');
    
    // Allow paste operation (Ctrl+V) if the element has prcinsAllowPaste directive
    if (hasAllowPasteDirective && e.keyCode === 86 && e.ctrlKey === true) {
      return;
    }
    
    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      //(e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      //(e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      // (e.keyCode == 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      ((e.keyCode >= 35 && e.keyCode <= 39) ||
      (e.keyCode >= 48 && e.keyCode <= 57) || 
      (e.keyCode >= 96 && e.keyCode <= 105)) && 
      !e.shiftKey
    ) {
      // let it happen, don't do anything
      return;
    } else{
      e.preventDefault();      
    }
  }
}
